import { render, staticRenderFns } from "./ProjectDetailsChild.vue?vue&type=template&id=3fb3779a&scoped=true&"
import script from "./ProjectDetailsChild.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsChild.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsChild.vue?vue&type=style&index=0&id=3fb3779a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb3779a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ProjectDetailsChild.vue
// module id = 339
// module chunks = 0